import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, Teleport as _Teleport } from "vue";
const _hoisted_1 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_2 = { class: "d-flex justify-content-between" };
const _hoisted_3 = { class: "form-check" };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "d-flex flex-wrap" };
const _hoisted_6 = {
    class: "modal fade",
    id: "create",
    tabindex: "-1",
    "aria-labelledby": "createModalLabel",
    "aria-hidden": "true"
};
const _hoisted_7 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_8 = { class: "modal-content" };
const _hoisted_9 = { class: "modal-body" };
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = { class: "form-floating mb-3" };
const _hoisted_12 = ["value"];
const _hoisted_13 = { class: "form-floating mb-3" };
const _hoisted_14 = ["value"];
const _hoisted_15 = { class: "form-floating mb-3" };
import { FilterMatchMode } from '@primevue/core/api';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, Link, useForm, usePage } from '@inertiajs/vue3';
import { onMounted, ref, watch } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import axios from 'axios';
import { Modal } from 'bootstrap';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Index',
    props: {
        orderRequestTypes: Object,
        defaultOrderRequestTypeId: Number,
        orderRequestChannels: Object
    },
    setup(__props) {
        let { formatDate } = formatters();
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        const props = __props;
        onMounted(() => {
        });
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const countries = usePage().props.countries;
        const orderRequests = ref([]);
        const hideCartType = ref(localStorage.getItem('orderRequestsHideCartType') === '1' ? true : false);
        const createForm = useForm({
            name: null,
            adminNotes: null,
            requestTypeId: props.defaultOrderRequestTypeId,
            requestChannelId: null,
            countryId: countries[0].id
        });
        onMounted(() => {
            orderRequests.value = loadOrderRequests();
        });
        //watch hideCartType
        watch(hideCartType, () => {
            localStorage.setItem('orderRequestsHideCartType', hideCartType.value ? '1' : '0');
            loadOrderRequests();
        });
        function loadOrderRequests() {
            axios.post(route('admin.orderRequests.load'), {
                hideCartType: hideCartType.value
            }).then((response) => {
                orderRequests.value = response.data.orderRequests;
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function createOrderRequest() {
            createForm.transform((data) => ({
                name: data.name,
                admin_notes: data.adminNotes,
                request_type_id: data.requestTypeId,
                request_channel_id: data.requestChannelId,
                country_id: data.countryId
            })).submit('post', route('admin.orderRequests.store'), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    const modal = Modal.getInstance(document.getElementById('create'));
                    modal.hide();
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Anfragen" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "fw-bold mb-3" }, "Anfragen & Angebote", -1)),
                        _createElementVNode("div", _hoisted_1, [
                            _cache[11] || (_cache[11] = _createElementVNode("button", {
                                class: "btn btn-secondary d-inline-flex align-items-center mb-3",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#create"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    class: "bi bi-plus-lg",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                    })
                                ]),
                                _createElementVNode("span", { class: "ms-2" }, "Neue Anfrage")
                            ], -1)),
                            _createVNode(_unref(DataTable), {
                                dataKey: "id",
                                value: orderRequests.value,
                                stripedRows: "",
                                responsiveLayout: "scroll",
                                globalFilterFields: ['name', 'type', 'customer', 'createdAt'],
                                filters: tableFilter.value,
                                "onUpdate:filters": _cache[2] || (_cache[2] = ($event) => ((tableFilter).value = $event)),
                                paginator: true,
                                rows: 10,
                                paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                                rowsPerPageOptions: [10, 25, 50, 150],
                                currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}"
                            }, {
                                header: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("div", _hoisted_3, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "hideCartType",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((hideCartType).value = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, hideCartType.value]
                                            ]),
                                            _cache[7] || (_cache[7] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "hideCartType"
                                            }, "Typ Warenkorb/Bestellung ausblenden", -1))
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                            placeholder: "Suche",
                                            style: { "width": "250px" }
                                        }, null, 512), [
                                            [_vModelText, tableFilter.value['global'].value]
                                        ])
                                    ])
                                ]),
                                empty: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                        _createElementVNode("div", { class: "p-3" }, " Keine Einträge gefunden ", -1)
                                    ]))]),
                                loading: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                        _createTextVNode(" Einträge werden geladen ... ", -1)
                                    ]))]),
                                default: _withCtx(() => [
                                    _createVNode(_unref(Column), {
                                        header: "#",
                                        sortable: true
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Erstellt",
                                        sortable: true,
                                        sortField: "createdAt"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createVNode(_unref(Link), {
                                                href: _ctx.route('admin.orderRequests.edit', slotProps.data.uuid)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.createdAt, true)), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["href"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "type",
                                        header: "Typ",
                                        sortable: true,
                                        sortField: "type"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "channel",
                                        header: "Anfragekanal",
                                        sortable: true,
                                        sortField: "channel"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "name",
                                        header: "Name",
                                        sortable: true,
                                        sortField: "name"
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Kunde",
                                        sortable: true,
                                        sortField: "customer"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            (slotProps.data.customer)
                                                ? (_openBlock(), _createBlock(_unref(Link), {
                                                    key: 0,
                                                    href: _ctx.route('admin.customers.edit', slotProps.data.customer.uuid)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(slotProps.data.customer.name), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["href"]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), { header: "" }, {
                                        body: _withCtx((slotProps) => [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createVNode(_unref(Link), {
                                                    href: _ctx.route('admin.orderRequests.edit', slotProps.data.uuid),
                                                    class: "btn btn-primary d-inline-flex align-items-center"
                                                }, {
                                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "16",
                                                                height: "16",
                                                                fill: "currentColor",
                                                                class: "bi bi-pencil-square text-white",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
                                                                _createElementVNode("path", {
                                                                    "fill-rule": "evenodd",
                                                                    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                                                })
                                                            ], -1)
                                                        ]))]),
                                                    _: 1
                                                }, 8, ["href"])
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["value", "filters"])
                        ])
                    ]),
                    _: 1
                }),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5 fw-bold",
                                        id: "createModalLabel"
                                    }, "Neue Anfrage"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(createOrderRequest, ["prevent"])
                                }, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "name",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(createForm).name) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createForm).name]
                                            ]),
                                            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "customerNo" }, "Name/Bezeichnung", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "requestChannel",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(createForm).requestChannelId) = $event)),
                                                required: ""
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orderRequestChannels, (requestChannel) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: requestChannel.id
                                                    }, _toDisplayString(requestChannel.name), 9, _hoisted_12));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(createForm).requestChannelId]
                                            ]),
                                            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "requestType" }, "Anfragekanal", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "country",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(createForm).countryId) = $event)),
                                                required: ""
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countries), (country) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: country.id
                                                    }, _toDisplayString(country.name), 9, _hoisted_14));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(createForm).countryId]
                                            ]),
                                            _cache[15] || (_cache[15] = _createElementVNode("label", { for: "country" }, "Lieferland", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_15, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                class: "form-control",
                                                id: "adminNotes",
                                                style: { "height": "100px" },
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(createForm).adminNotes) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createForm).adminNotes]
                                            ]),
                                            _cache[16] || (_cache[16] = _createElementVNode("label", { for: "adminNotes" }, "Anmerkungen", -1))
                                        ])
                                    ]),
                                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ])
                ]))
            ], 64));
        };
    }
});
